module.exports = __webpack_public_path__ + "img/loja-protegida.90244f28.png";